/**
 * Breadcrumbs
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import clsx from 'clsx';
import React from 'react';
import { Grid, Cell } from 'ui-component-library/base';
/** List of links styled as breadcrumbs. */
var Breadcrumbs = function (_a) {
    var children = _a.children, className = _a.className, ariaLabel = _a["aria-label"];
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) {
            var className = '';
            if (index === 0) {
                className += 'root';
            }
            if (index === children.length - 1) {
                className += ' current';
            }
            else if (index === children.length - 2) {
                className += ' parent';
            }
            return React.cloneElement(child, __assign(__assign({}, child.props), { key: index, className: className }));
        });
    };
    return (React.createElement("div", { "data-cid": "Breadcrumbs", className: clsx(className, 'py-4 border-b-borderWidth border-borderColor') },
        React.createElement(Grid, { padding: false, className: "pl-4 lg:pl-6" },
            React.createElement(Cell, { span: 12 },
                React.createElement("nav", { "aria-label": ariaLabel },
                    React.createElement("ul", { className: "text-lg text-alt leading-6" }, renderChildren(children)))))));
};
export default Breadcrumbs;
